var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAppBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 724,
    height: 784,
    viewBox: "0 0 724 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M111.768 122.6C-11.7494 113.034 -8.97534 42.0902 -52.1083 0L-356 223.843C-292.608 415.163 -128.31 886.339 -84.3929 763.895C21.2321 426.272 184.09 557.006 415.44 648.839C646.789 740.672 853.029 582.824 624.804 303.672C396.578 -92.4219 235.285 132.166 111.768 122.6Z",
    fill: "#5DC6AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M256.032 682.177C251.999 711.718 226.149 700.8 188.351 695.639C150.552 690.479 115.117 693.03 119.15 663.489C123.184 633.948 157.095 614.183 194.894 619.344C232.693 624.505 260.065 652.636 256.032 682.177Z",
    fill: "#5DC6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M662.779 151.961C650.519 164.221 638.757 143.473 601.479 134.986C562.813 134.986 554.683 109.081 571.301 89.1912C587.918 69.3013 612.787 67.4931 638.757 89.1903C664.728 110.888 672.21 134.986 662.779 151.961Z",
    fill: "#5DC6AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppBg);
export default __webpack_public_path__ + "static/media/downloadAppBg.a494e62f99dc817b5a8c680e089a7b8b.svg";
export { ForwardRef as ReactComponent };